import { ref, onUnmounted, computed } from 'vue-demi';
const { useBehaviour, useUser, useVariable } = require('@fegobull/webapi').use;

export const useFego = () => {
    const isRender = ref(!window.FEGOEditor);
    const getFegoData = () => {
        if (isRender.value) {
            const data = useVariable();
            return data;
        }
        return { NOW_SERVER: 0 };
    };

    const getUser = () => {
        if (isRender.value) {
            const { uid, isLogin } = useUser();
            return { uid, isLogin };
        }
        return { uid: 0, isLogin: false };
    };

    const isLog = (evt, jump = true) => {
        if (!useBehaviour || !useUser) {
            return true;
        }
        const { runBehaviour } = useBehaviour();
        const { uid, isLogin } = useUser();
        if (!uid || !isLogin) {
            if (jump) {
                runBehaviour(
                    evt,
                    {
                        type: 'login',
                        loginType: 'login'
                    },
                    evt || null, 'jumpLogin'
                );
            }
            return false;
        }
        return true;
    };

    return {
        isRender,
        getFegoData,
        getUser,
        isLog
    };
};
